import {
  addBackupsForLiteParentChildItem,
  addTempBackgroundImage,
  askIfUserNeedImprintText,
  backupLogoDataBeforeCrop,
  backupStockImageType,
  changeCanvasStatus,
  changeHeightFits,
  changeImprintAreaDimension,
  changeInitializedImprintAreaKeys,
  changeLogoEditingStatus,
  changeScale,
  finishOfflineChat,
  firstShiftTab,
  hasInvalidCharacter,
  hideConfirmDialog,
  hideMessageBox,
  hideTransparencyCover,
  hideWaitingCover,
  imprintOptionUIInitialize,
  imprintOptionUISet,
  initialOfflineChatBox,
  initializeActiveCart,
  initializeBomPreview,
  initializeCartUseScene7Template,
  initializeCharges,
  initializeDetailInfo,
  initializeImprintAreaDimension,
  initializeItemSpec,
  initializeNavInkPreconfigurationParameters,
  initializeOrder,
  initializeParameters,
  initializeSaveProject,
  initializeShipping,
  initializeSpecialSymbols,
  initializeTemplatePreviewDict,
  initializeTrackingPixelScript,
  initializeUser,
  initializeVendor,
  isTextColorEditing,
  isValidReturnUrl,
  removeTempBackgroundImage,
  saveProjectData,
  saveZipCode,
  sendOfflineChatError,
  setAllDataLoadedForLite,
  setBeforeUnloadListen,
  setCanvasPreview,
  setCurrentAskNeedImprintOptionInfo,
  setCurrentImprintAreaKey,
  setCurrentImprintOptionStep,
  setCurrentStep,
  setElementDragFlag,
  setExternalWaitingCoverId,
  setGuideMode,
  setNeedImprintOptionMode,
  setNewUploadLogoFlag,
  setOfflineChatLoading,
  setParameterToken,
  setPrevLiteSharedArtColorsDict,
  setPrevLiteSharedArtDict,
  setProp65MessageOneOff,
  setRegisterForEmailUpdates,
  setTopPaddingHeightOfImprintView,
  showApplyToAllButton,
  showConfirmDialog,
  showMessageBox,
  showTransparencyCover,
  showWaitingCover,
  switchShowViewPricingPanel,
  switchShowWarningMessageContainer,
  toggleBatchSelectFlagForTouch,
  tokenExpirationPopupToggle,
  tokenWarningPopupToggle,
  updateReturningUrl,
  updateSaveProject,
  updateShipping,
  updateTempBackgroundImage,
  updateWaitingCover,
} from './actions';
import {
  canvasResizingPhase,
  logoEditingStatusEnum,
  modalType,
  sidebarTabKeyEnum,
  textEditingStatus,
} from '../utils/constants';
import {
  changeBackgroundStep,
  changeTempRecentBackground,
  clearCurrentActiveCommonTemplate,
  initializeBackgroundDesignPanelShownFlags,
  saveCurrentActiveCommonTemplate,
  setBackgroundDesignPanelShownFlag,
} from '../template/actions';
import {
  changeBomColor,
  changeLiteBomColor,
  changeLitePreview,
  changePreview,
  hidePreviewPopup,
  initDefaultUrlIndex,
  initMoreviews,
  setPreviewDefaultImprintColorDict,
  showPreviewPopup,
  updateFullPreview,
} from '../preview/actions';
import {
  changeCanvasResizeParameters,
  changeCropParameter,
  setItemStyleOriginSize,
  setSelectingTemplateFlag,
  setUi,
  unSelectAllText,
} from '../canvas/actions';
import { changeTextEditingStatus, showAddText } from '../text/actions';
import { configuratorStep, imprintOptionStep } from './constants';
import { endPrinting, hideModal, showModal, startPrinting } from '../tools/actions';
import {
  resetCurrentParentChildOptionEditingInfo,
  setCurrentParentChildOptionEditingInfo,
  setShowSizeChartForMobileLite,
} from '../bom/actions';
import {
  setCurrentUpsellItemId,
  setCurrentUpsellType,
  setCurrentUpsellsValidationStatus,
  setOptionalUpsellsExcluded,
} from '../upsell/actions';
import { setGroupSelectedRule, setImprintGroups, skipGroupRuleSelect } from './actions';

import { backgroundStep } from '../template/constants';
import { changePreviewNextGen } from '../nextgen/preview/actions';
import { changeSidebarTabKey } from '../sidebar/actions';
import { confirmDialogContentType } from '../nextgen/constants';
import { createReducer } from '@reduxjs/toolkit';
import { switchAskIfUserNeedImprintOption } from '../canvas/actions';

export const specs = createReducer({}, (builder) => {
  builder.addCase(initializeItemSpec, (state, action) => action.payload);
});

export const parameters = createReducer({}, (builder) => {
  builder
    .addCase(initializeParameters, (state, action) => {
      if (action.payload && action.payload.itemSku) {
        action.payload.itemSku = action.payload.itemSku.toUpperCase();
      }
      Object.assign(state, action.payload);
    })
    .addCase(setParameterToken, (state, action) => {
      state.token = action.payload;
    })
    .addCase(saveZipCode, (state, action) => {
      state.zip = action.payload;
    })
    .addCase(initializeNavInkPreconfigurationParameters, (state, action) => {
      const { lastUpdateTs, preconfigurationId } = action.payload;
      state.eTag = lastUpdateTs;
      state.preconfigurationId = preconfigurationId;
    });
});

export const vendor = createReducer({}, (builder) => {
  builder.addCase(initializeVendor, (state, action) => action.payload);
});

export const detailInfo = createReducer({}, (builder) => {
  builder.addCase(initializeDetailInfo, (state, action) => action.payload);
});

export const activeCart = createReducer({}, (builder) => {
  builder.addCase(initializeActiveCart, (state, action) => action.payload);
});

// export const upsells = createReducer([], {
//   [initializeUpsells],(state, action) => action.payload,
//   [updateUpsellQuantity],(state, action) => {
//     const itemId = action.payload.itemId;
//     const quantity = action.payload.quantity;
//     let upsellItem = state.find((upsell) => upsell.item.itemId === itemId);
//     if (upsellItem) {
//       upsellItem.totalQuantity = quantity;
//     }
//   },
//   [toggleUpsellSelectedStatus],(state, action) => {
//     const { itemId, isSelected } = action.payload;
//     const target = state.find((upsell) => upsell && upsell.item && upsell.item.itemId && upsell.item.itemId === itemId);
//     if (target) {
//       target.isSelected = isSelected;
//       if (!isSelected) target.totalQuantity = 0;
//     }
//   },
// });

export const trackingPixelScript = createReducer({}, (builder) => {
  builder.addCase(initializeTrackingPixelScript, (state, action) => action.payload);
});

export const user = createReducer(null, (builder) => {
  builder.addCase(initializeUser, (state, action) => action.payload);
});

export const charges = createReducer([], (builder) => {
  builder.addCase(initializeCharges, (state, action) => action.payload);
});

export const saveProject = createReducer({}, (builder) => {
  builder
    .addCase(initializeSaveProject, (state, action) => action.payload)
    .addCase(updateSaveProject, (state, action) => {
      const { email, name } = action.payload;
      state.email = email;
      state.name = name;
    })
    .addCase(updateReturningUrl, (state, action) => {
      state.returningUrl = action.payload;
    });
});

const uiInitState = {
  currentSidebarTabKey: sidebarTabKeyEnum.WhatsNext,
  waitingCover: {
    show: false,
    showProgress: false,
    showSpinner: true,
    percent: 0,
    text: '',
    textStyle: '',
    textIcon: '',
    spinnerSize: '',
  },
  transparencyCover: { show: false, showImageCropPopup: false },
  messageBox: {
    show: false,
    message: '',
    title: '',
  },
  confirmDialog: {
    show: false,
    tile: '',
    okText: 'Ok',
    cancelText: 'Cancel',
    onOk: null,
    onCancel: null,
    contentType: confirmDialogContentType.None,
    contentProps: {},
  },
  logoEditingStatus: { currentStatus: logoEditingStatusEnum.None, newLogoFlag: true },
  tempBackgroundImage: {},
  backgroundStep: backgroundStep.Init,
  tempRecentBackground: null,
  tempTextEntered: '',
  elementDragFlag: false,
  batchSelectFlagForTouch: false,
  currentImprintAreaKey: '',
  initializedImprintAreaKeys: [],
  currentModal: modalType.None,
  scene7Urls: [],
  step: configuratorStep.loading,
  bomPreview: {},
  canvasPreview: {},
  fullPreviewDict: {},
  templatePreviewDict: {},
  moreviews: {},
  moreviewsLite: {
    previewIndex: 0,
    colorIndex: 0,
  },
  moreviewsNextGen: {
    previewIndex: 0,
  },
  showTokenWarning: false,
  showTokenExpiration: false,
  canvasResize: {},
  beforeUnloadListening: true,
  currentUpsellItemId: '',
  currentUpsellsValidationStatus: { invalidItemId: '', showMessageBox: false },
  currentImprintOptionStep: imprintOptionStep.NA,
  imprintOption: {},
  imprintAreaDimension: {},
  scaleDict: {},
  heightFits: {},
  hasInvalidCharacter: false,
  firstShiftTab: true,
  isTextColorEditing: false,
  showApplyToAllButton: false,
  currentParentChildOptionEditingInfo: { isEditing: false, parentOption: null, parentQuestion: null },
  guideMode: {},
  warningMessage: {
    show: false,
    message: [],
  },
  currentUpsellType: null,
  optionalUpsellsExcluded: false,
  textEditingStatus: textEditingStatus.Init,
  currentActiveCommonTemplate: null,
  backgroundDesignPanelShownFlags: {},
  askIfUserNeedImprintText: false,
  askIfUserNeedImprintOption: false,
  setTopPaddingHeightOfImprintView: 70,
  saveProjectData: {
    firstShowSaveProjectModel: true,
    hasSavedProject: false,
    savedProjectData: {},
  },
  showSizeChartForMobileLite: false,
  needImprintOptionMode: {},
  currentAskNeedImprintOptionInfo: {},
  allDataLoadedForLite: false,
  stockImageTypeDict: {},
  registerForEmailUpdates: true,
  prevLiteSharedArtDict: {},
  prevLiteSharedArtColorsDict: {},
  externalWaitingCoverId: '',
  previewDefaultImprintColorDict: {},
  isValidReturnUrl: true,
  imprintGroups: [],
};

export const ui = createReducer(uiInitState, (builder) => {
  builder
    .addCase(setUi, (state, action) => {
      Object.assign(state, action.payload);
    })
    .addCase(initializeCartUseScene7Template, (state, action) => {
      state.cartUseScene7Template = action.payload;
    })
    .addCase(setSelectingTemplateFlag, (state, action) => {
      state.isSelectingTemplate = action.payload;
    })
    .addCase(setCurrentAskNeedImprintOptionInfo, (state, action) => {
      state.currentAskNeedImprintOptionInfo = action.payload;
    })
    .addCase(setNeedImprintOptionMode, (state, action) => {
      Object.keys(action.payload).forEach((imprintAreaKey) => {
        state.needImprintOptionMode[imprintAreaKey] = action.payload[imprintAreaKey];
      });
    })
    .addCase(setGuideMode, (state, action) => {
      Object.keys(action.payload).forEach((imprintAreaKey) => {
        state.guideMode[imprintAreaKey] = action.payload[imprintAreaKey];
      });
    })
    .addCase(initializeBomPreview, (state, action) => {
      state.bomPreview = action.payload;
    })
    .addCase(setCanvasPreview, (state, action) => {
      const { imprintAreaKey, canvasPreview } = action.payload;
      Object.assign(state.canvasPreview, { [imprintAreaKey]: canvasPreview });
    })
    .addCase(setItemStyleOriginSize, (state, action) => {
      // itemStyleOriginSize only need to be set once
      const { width, height } = action.payload;
      if (state.canvasResize[action.payload.imprintAreaKey]) {
        state.canvasResize[action.payload.imprintAreaKey].itemStyleOriginSize = { width, height };
      } else {
        state.canvasResize[action.payload.imprintAreaKey] = {
          itemStyleOriginSize: { width, height },
        };
      }
    })
    .addCase(changeCanvasResizeParameters, (state, action) => {
      if (state.canvasResize[action.payload.imprintAreaKey]) {
        if (action.payload.scale) state.canvasResize[action.payload.imprintAreaKey].scale = action.payload.scale;

        if (action.payload.resizingPhase)
          state.canvasResize[action.payload.imprintAreaKey].resizingPhase = action.payload.resizingPhase;
        if (action.payload.sideBarWidth)
          state.canvasResize[action.payload.imprintAreaKey].sideBarWidth = action.payload.sideBarWidth;
        if (action.payload.canvasWidth)
          state.canvasResize[action.payload.imprintAreaKey].canvasWidth = action.payload.canvasWidth;
        if (action.payload.availableCanvasAreaWidth !== undefined)
          state.canvasResize[action.payload.imprintAreaKey].availableCanvasAreaWidth =
            action.payload.availableCanvasAreaWidth;
        if (action.payload.maxAvailableCanvasAreaWidth !== undefined)
          state.canvasResize[action.payload.imprintAreaKey].maxAvailableCanvasAreaWidth =
            action.payload.maxAvailableCanvasAreaWidth;
        if (action.payload.canvasZoom !== undefined)
          state.canvasResize[action.payload.imprintAreaKey].canvasZoom = action.payload.canvasZoom;
        if (action.payload.zoomValue !== undefined)
          state.canvasResize[action.payload.imprintAreaKey].zoomValue = action.payload.zoomValue;
        if (action.payload.editPanelHeight)
          state.canvasResize[action.payload.imprintAreaKey].editPanelHeight = action.payload.editPanelHeight;
        if (action.payload.fixedContainerChangeFlag)
          state.canvasResize[action.payload.imprintAreaKey].fixedContainerChangeFlag =
            action.payload.fixedContainerChangeFlag;
        if (action.payload.pageHeight !== undefined)
          state.canvasResize[action.payload.imprintAreaKey].pageHeight = action.payload.pageHeight;
      } else {
        state.canvasResize[action.payload.imprintAreaKey] = {
          scale: action.payload.scale || 1,
          resizingPhase: action.payload.resizingPhase || canvasResizingPhase.OneRowAndNoResizing,
          sideBarWidth: action.payload.sideBarWidth || 0,
          canvasWidth: action.payload.canvasWidth || 0,
          editPanelHeight: action.payload.editPanelHeight || 0,
          fixedContainerChangeFlag: null,
        };
      }
    })
    .addCase(changeSidebarTabKey, (state, action) => {
      state.currentSidebarTabKey = action.payload;
    })
    .addCase(showMessageBox, (state, action) => {
      if (typeof action.payload == 'string') {
        state.messageBox.message = action.payload;
        state.messageBox.show = true;
      } else state.messageBox = { ...action.payload, show: true };
    })
    .addCase(hideMessageBox, (state, action) => {
      state.messageBox = { show: false };
    })
    .addCase(showConfirmDialog, (state, action) => {
      //const {title, message, onOk, onCancel } = action.payload;
      state.confirmDialog = { ...action.payload, show: true };
    })
    .addCase(hideConfirmDialog, (state, payload) => {
      state.confirmDialog = {
        show: false,
        tile: '',
        okText: 'Ok',
        cancelText: 'Cancel',
        onOK: null,
        onCancel: null,
        contentType: confirmDialogContentType.None,
        contentProps: {},
      };
    })
    .addCase(showWaitingCover, (state, action) => {
      state.waitingCover = { ...state.waitingCover, ...action.payload, show: true };
    })
    .addCase(hideWaitingCover, (state, action) => {
      if (action && action.payload && action.payload.reset) {
        state.waitingCover = {};
      } else if (state.waitingCover && state.waitingCover.forceShowWaitingCover) {
        return;
      } else {
        state.waitingCover.show = false;
      }
    })
    .addCase(showTransparencyCover, (state, action) => {
      state.transparencyCover = { ...action.payload, show: true };
    })
    .addCase(hideTransparencyCover, (state, action) => {
      state.transparencyCover.showImageCropPopup = false;
      state.transparencyCover.show = false;
    })
    .addCase(updateWaitingCover, (state, action) => {
      if (action.payload.percent) state.waitingCover.percent = Math.floor(action.payload.percent);
      if (action.payload.text) state.waitingCover.text = action.payload.text;
      if (action.payload.showProgress) state.waitingCover.showProgress = action.payload.showProgress;
      if (action.payload.showSpinner) state.waitingCover.showSpinner = action.payload.showSpinner;
      if (action.payload.spinnerSize) state.waitingCover.spinnerSize = action.payload.spinnerSize;
      if (action.payload.textStyle) state.waitingCover.textStyle = action.payload.textStyle;
      if (action.payload.textIcon) state.waitingCover.textIcon = action.payload.textIcon;
      if (action.payload.forceShowWaitingCover) {
        state.waitingCover.forceShowWaitingCover = action.payload.forceShowWaitingCover;
      }
      // prevent the waitingcover from being hidden by other code
      state.waitingCover.show = true;
    })

    .addCase(changeLogoEditingStatus, (state, action) => {
      state.logoEditingStatus = state.logoEditingStatus || { currentStatus: logoEditingStatusEnum.None };
      if (typeof action.payload === 'number') state.logoEditingStatus.currentStatus = action.payload;
      else {
        Object.assign(state.logoEditingStatus, action.payload);
      }
    })

    .addCase(changeCanvasStatus, (state, action) => {
      state.canvasStatus = state.canvasStatus || {};
      if (action.payload.refreshFlag) state.canvasStatus.refreshFlag = action.payload.refreshFlag;
    })

    .addCase(addTempBackgroundImage, (state, action) => {
      const newBackgroundImage = { data: action.payload, ui: {} };
      state.tempBackgroundImage = {};
      Object.assign(state.tempBackgroundImage, newBackgroundImage);
      state.tempBackgroundImage.origin = {};
      Object.assign(state.tempBackgroundImage.origin, newBackgroundImage);
    })

    .addCase(updateTempBackgroundImage, (state, action) => {
      Object.assign(state.tempBackgroundImage.data, action.payload);
    })

    .addCase(removeTempBackgroundImage, (state) => {
      state.tempBackgroundImage = null;
    })

    .addCase(setElementDragFlag, (state, action) => {
      state.elementDragFlag = action.payload;
    })

    .addCase(toggleBatchSelectFlagForTouch, (state, action) => {
      state.batchSelectFlagForTouch = !state.batchSelectFlagForTouch;
    })

    .addCase(hideModal, (state) => {
      state.currentModal = modalType.None;
    })
    .addCase(showModal, (state, action) => {
      state.currentModal = action.payload;
    })
    .addCase(startPrinting, (state, action) => {
      state.printKeys = action.payload;
      state.print = true;
      state.waitingCover.show = true;
    })
    .addCase(endPrinting, (state, action) => {
      state.print = false;
      state.waitingCover.show = false;
    })
    .addCase(showAddText, (state, action) => {
      state.showAddText = true;
    })
    .addCase(unSelectAllText, (state, action) => {
      state.showAddText = false;
    })
    .addCase(changeTextEditingStatus, (state, action) => {
      state.textEditingStatus = action.payload;
    })
    .addCase(initMoreviews, (state, action) => {
      action.payload.imprintAreaKeys.forEach((imprintAreaKey) => {
        state.moreviews[imprintAreaKey] = {
          previewIndex: 0,
          colorIndex: 0,
        };
      });
    })
    .addCase(initDefaultUrlIndex, (state, action) => {
      action.payload.imprintAreaKeys.forEach((imprintAreaKey) => {
        let fullPreviewUrls = [];
        if (imprintAreaKey in action.payload.fullPreviewDict)
          fullPreviewUrls = [...action.payload.fullPreviewDict[imprintAreaKey]];

        let defaultUrl = fullPreviewUrls && fullPreviewUrls.find((item) => item.isDefault);
        if (defaultUrl) {
          const index = fullPreviewUrls.findIndex((item) => item.isDefault);
          if (index > 0) {
            state.moreviews[imprintAreaKey].previewIndex = index;
          }
        }
      });
    })
    .addCase(changeBomColor, (state, action) => {
      action.payload.imprintAreaKeys.forEach((key) => {
        if (state.moreviews[key]) {
          state.moreviews[key].colorIndex = action.payload.selectedIndex;
        }
      });
    })
    .addCase(changePreview, (state, action) => {
      if (state.moreviews[action.payload.imprintAreaKey]) {
        state.moreviews[action.payload.imprintAreaKey].previewIndex = action.payload.selectedIndex;
      }
    })
    .addCase(changeLiteBomColor, (state, action) => {
      state.moreviewsLite.colorIndex = action.payload;
    })
    .addCase(changeLitePreview, (state, action) => {
      state.moreviewsLite.previewIndex = action.payload.selectedIndex;
    })
    .addCase(changePreviewNextGen, (state, action) => {
      state.moreviewsNextGen.previewIndex = action.payload;
    })
    .addCase(showPreviewPopup, (state) => {
      state.currentModal = modalType.Preview;
    })
    .addCase(hidePreviewPopup, (state, action) => {
      state.currentModal = modalType.None;
    })
    .addCase(updateFullPreview, (state, action) => {
      Object.keys(action.payload).forEach((key) => {
        state.fullPreviewDict[key] = action.payload[key];
      });
    })
    .addCase(setCurrentStep, (state, action) => {
      state.step = action.payload;
    })
    .addCase(setCurrentImprintAreaKey, (state, action) => {
      state.currentImprintAreaKey = action.payload;
    })
    .addCase(initializeTemplatePreviewDict, (state, action) => {
      Object.assign(state.templatePreviewDict, action.payload);
    })
    .addCase(setProp65MessageOneOff, (state, _) => {
      state.prop65MessageOneOff = true;
    })
    .addCase(tokenWarningPopupToggle, (state, action) => {
      state.showTokenWarning = action.payload;
    })
    .addCase(tokenExpirationPopupToggle, (state, action) => {
      state.showTokenExpiration = action.payload;
    })
    .addCase(changeInitializedImprintAreaKeys, (state, action) => {
      for (let imprintAreaKey of action.payload) {
        if (state.initializedImprintAreaKeys.indexOf(imprintAreaKey) === -1) {
          state.initializedImprintAreaKeys.push(imprintAreaKey);
        }
      }
    })
    .addCase(switchShowViewPricingPanel, (state, action) => {
      state.showViewPricingPanel = action.payload;
    })
    .addCase(setBeforeUnloadListen, (state, action) => {
      state.beforeUnloadListening = action.payload;
    })

    .addCase(setCurrentUpsellsValidationStatus, (state, action) => {
      state.currentUpsellsValidationStatus = action.payload;
    })
    .addCase(setCurrentImprintOptionStep, (state, action) => {
      state.currentImprintOptionStep = action.payload;
    })
    .addCase(imprintOptionUISet, (state, action) => {
      state.imprintOption = action.payload;
    })
    .addCase(imprintOptionUIInitialize, (state, action) => {
      const { formatkey, option } = action.payload;
      state.imprintOption[formatkey] = Object.assign({}, state.imprintOption[formatkey], option);
    })
    .addCase(initializeImprintAreaDimension, (state, action) => {
      Object.keys(action.payload).forEach((key) => (state.imprintAreaDimension[key] = action.payload[key]));
    })
    .addCase(changeImprintAreaDimension, (state, action) => {
      state.imprintAreaDimension[action.payload.imprintAreaKey][action.payload.logoLocation] =
        action.payload.imprintAreaDimension;
    })
    .addCase(changeScale, (state, action) => {
      state.scaleDict[action.payload.imprintAreaKey] = action.payload.scale;
    })
    .addCase(changeHeightFits, (state, action) => {
      state.heightFits[action.payload.imprintAreaKey] = action.payload.heightFits;
    })
    .addCase(initializeSpecialSymbols, (state, action) => {
      state.specialSymbols = action.payload;
    })
    .addCase(hasInvalidCharacter, (state, action) => {
      const invalidCharacters = action.payload;
      if (invalidCharacters === '') {
        state.hasInvalidCharacter = false;
      } else {
        state.hasInvalidCharacter = true;
      }
    })
    .addCase(firstShiftTab, (state, action) => {
      state.firstShiftTab = action.payload;
    })
    .addCase(isTextColorEditing, (state, action) => {
      state.isTextColorEditing = action.payload;
    })
    .addCase(showApplyToAllButton, (state, action) => {
      state.showApplyToAllButton = action.payload;
    })
    .addCase(setCurrentUpsellItemId, (state, action) => {
      state.currentUpsellItemId = action.payload;
    })
    .addCase(setCurrentParentChildOptionEditingInfo, (state, action) => {
      state.currentParentChildOptionEditingInfo = action.payload;
    })
    .addCase(resetCurrentParentChildOptionEditingInfo, (state, action) => {
      state.currentParentChildOptionEditingInfo = {
        isEditing: false,
        parentOption: null,
        parentQuestion: null,
      };
    })
    .addCase(switchShowWarningMessageContainer, (state, action) => {
      state.warningMessage.show = action.payload.show;
      if (action.payload.show) state.warningMessage.message = action.payload.message;
    })
    .addCase(setCurrentUpsellType, (state, action) => {
      state.currentUpsellType = action.payload;
    })
    .addCase(setOptionalUpsellsExcluded, (state, action) => {
      state.optionalUpsellsExcluded = true;
    })

    .addCase(setNewUploadLogoFlag, (state, action) => {
      state.logoEditingStatus.newLogoFlag = action.payload;
    })
    .addCase(backupLogoDataBeforeCrop, (state, action) => {
      state.logoEditingStatus.logoDataBeforeCrop = action.payload;
    })
    .addCase(changeCropParameter, (state, action) => {
      state.logoEditingStatus.cropParam = action.payload;
    })
    .addCase(clearCurrentActiveCommonTemplate, (state, action) => {
      state.currentActiveCommonTemplate = null;
    })
    .addCase(saveCurrentActiveCommonTemplate, (state, action) => {
      state.currentActiveCommonTemplate = action.payload;
    })
    .addCase(initializeBackgroundDesignPanelShownFlags, (state, action) => {
      const { imprintAreaKeys } = action.payload;
      state.backgroundDesignPanelShownFlags = Object.fromEntries(imprintAreaKeys.map((key) => [key, false]));
    })
    .addCase(setBackgroundDesignPanelShownFlag, (state, action) => {
      const { imprintAreaKey } = action.payload;
      if (Object.keys(state.backgroundDesignPanelShownFlags).includes(imprintAreaKey)) {
        state.backgroundDesignPanelShownFlags[imprintAreaKey] = true;
      }
    })
    .addCase(askIfUserNeedImprintText, (state, action) => {
      state.askIfUserNeedImprintText = action.payload;
    })
    .addCase(switchAskIfUserNeedImprintOption, (state, action) => {
      state.askIfUserNeedImprintOption = action.payload;
    })
    .addCase(setTopPaddingHeightOfImprintView, (state, action) => {
      state.setTopPaddingHeightOfImprintView = action.payload;
    })
    .addCase(saveProjectData, (state, action) => {
      if (action.payload.hasSavedProject !== undefined)
        state.saveProjectData.hasSavedProject = action.payload.hasSavedProject;
      if (action.payload.savedProjectData !== undefined)
        state.saveProjectData.savedProjectData = action.payload.savedProjectData;
      if (action.payload.firstShowSaveProjectModel !== undefined)
        state.saveProjectData.firstShowSaveProjectModel = action.payload.firstShowSaveProjectModel;
    })
    .addCase(setShowSizeChartForMobileLite, (state, action) => {
      state.showSizeChartForMobileLite = action.payload;
    })
    .addCase(setAllDataLoadedForLite, (state, action) => {
      state.allDataLoadedForLite = action.payload;
    })
    .addCase(backupStockImageType, (state, action) => {
      const { key, stockImageType } = action.payload;
      state.stockImageTypeDict[key] = stockImageType;
    })
    .addCase(setRegisterForEmailUpdates, (state, action) => {
      state.registerForEmailUpdates = action.payload;
    })
    .addCase(setPrevLiteSharedArtDict, (state, action) => {
      state.prevLiteSharedArtDict = action.payload;
    })
    .addCase(setPrevLiteSharedArtColorsDict, (state, action) => {
      state.prevLiteSharedArtColorsDict = action.payload;
    })
    .addCase(setExternalWaitingCoverId, (state, action) => {
      state.externalWaitingCoverId = action.payload;
    })
    .addCase(setPreviewDefaultImprintColorDict, (state, action) => {
      const { imprintAreaKey, defaultImprintColor } = action.payload;
      Object.assign(state.previewDefaultImprintColorDict, { [imprintAreaKey]: defaultImprintColor });
    })
    .addCase(isValidReturnUrl, (state, action) => {
      state.isValidReturnUrl = action.payload;
    })
    .addCase(changeBackgroundStep, (state, action) => {
      state.backgroundStep = action.payload;
    })
    .addCase(setImprintGroups, (state, action) => {
      state.imprintGroups = action.payload;
    })
    .addCase(setGroupSelectedRule, (state, action) => {
      const { groupName, selectedRule } = action.payload;
      const group = state.imprintGroups[groupName];

      if (group) {
        let imprintRules = group.imprintRules;

        Object.keys(imprintRules).forEach((key) => {
          imprintRules[key].isSelected = key === selectedRule;
        });
      }
    })
    .addCase(skipGroupRuleSelect, (state, action) => {
      const groupName = action.payload;
      state.imprintGroups[groupName].needSelect = false;
    })
    .addCase(changeTempRecentBackground, (state, action) => {
      state.tempRecentBackground = action.payload;
    });
});
export const order = createReducer({}, (builder) => {
  builder.addCase(initializeOrder, (state, action) => action.payload);
});

export const shipping = createReducer({}, (builder) => {
  builder
    .addCase(initializeShipping, (state, action) => action.payload)
    .addCase(updateShipping, (state, action) => action.payload);
});

export const backups = createReducer({}, (builder) => {
  builder.addCase(addBackupsForLiteParentChildItem, (state, action) => {
    state[action.payload.key] = action.payload.value;
  });
});

export const offlineChat = createReducer(
  {
    step: '', //step: chating, finish, error,
    errorMessage: '',
    loading: false,
  },
  (builder) => {
    builder
      .addCase(initialOfflineChatBox, (state, action) => {
        state.step = 'chating';
        state.errorMessage = '';
        state.loading = false;
      })
      .addCase(finishOfflineChat, (state, action) => {
        state.step = 'finish';
        state.loading = false;
      })
      .addCase(sendOfflineChatError, (state, action) => {
        state.step = 'error';
        state.errorMessage = action.payload;
        state.loading = false;
      })
      .addCase(setOfflineChatLoading, (state, action) => {
        state.loading = true;
      });
  }
);
